module.exports = __webpack_public_path__ + "AR.png?461d337dde65fc89460b577d3e39d96a";